module.exports = __webpack_public_path__ + "0dd67c52c67e3dc369536e80416c10bd.pdf";